<template>
  <q-chip
    v-show="count >= min"
    :label="count"
    :size="size"
    :color="color"
    :text-color="textColor"
    :outline="outline"
    :class="{'q-chip--soft': outline}"
    class="text-weight-bold"
  >
    <q-tooltip>{{ title }}</q-tooltip>
  </q-chip>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

interface Config {
  color: string,
  title: string,
}

interface ConfigMap {
  [key: string]: Config
}

const config: ConfigMap = {
  unreviewed: {
    color: 'primary',
    title: 'Unreviewed',
  },
  escalated: {
    color: 'warning',
    title: 'Escalated',
  },
};

export default defineComponent({
  props: {
    count: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 1,
    },
  },
  computed: {
    config(): Config {
      return config[this.type];
    },
    color(): string {
      return this.config.color;
    },
    textColor(): string {
      return this.outline ? this.color : 'white';
    },
    title(): string {
      return `${this.config.title} Posts`;
    },
  },
});
</script>
